import { useEffect } from "react";
export var useBlurOnChipBlur = function useBlurOnChipBlur(_ref) {
  var ref = _ref.ref,
    activeIndex = _ref.activeIndex,
    setActiveIndex = _ref.setActiveIndex;
  useEffect(function () {
    var manageBlur = function manageBlur(e) {
      var _ref$current;
      if (!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(e.target)) && activeIndex > -1) {
        /* NOTE: -2 is a hack to get around downshift's automatic refocusing of the dropdown
         * element when activeIndex is set to -1. We need to do this to blur all chips when
         * the multiselect is blurred.
         *
         * See: https://github.com/downshift-js/downshift/blob/master/src/hooks/useMultipleSelection/index.js#L87
         */

        setActiveIndex(-2);
      }
    };
    document.addEventListener("click", manageBlur);
    return function () {
      document.removeEventListener("click", manageBlur);
    };
  }, [ref, activeIndex, setActiveIndex]);
};
//# sourceMappingURL=useBlurChipOnBlur.js.map